import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import {OnboardingUnitTypeAndUnitsData} from 'units/UnitDictionaryDAO';
import {UnitTypesQueryUnitTypeNode} from 'units/UnitsConstants';

import {
  UnitsDependencyDataStructures,
  getNewSelectedUnitTypesAndUnits,
  getUnitTypeForceSelectedText,
} from './OnboardingWizardUtil';
import UnitsOnboardingWizardUnitTypeRow from './UnitsOnboardingWizardUnitTypeRow';

interface UnitsOnboardingWizardUnitTypesScreen {
  defaultUnitsData: Array<OnboardingUnitTypeAndUnitsData>;
  selectedUnitTypeNames: Array<string>;
  selectedUnitSymbols: Array<string>;
  onSetSelectedUnitTypeNames: (selectedUnitTypeNames: Array<string>) => void;
  onSetSelectedUnitSymbols: (selectedUnitSymbols: Array<string>) => void;
  onSetCurrentUnitTypeName: (currentUnitTypeName: string | null) => void;
  unitsDependencyDataStructures: UnitsDependencyDataStructures;
  existingUnitTypes: Array<UnitTypesQueryUnitTypeNode>;
}

export default function UnitsOnboardingWizardUnitTypesScreen({
  defaultUnitsData,
  selectedUnitTypeNames,
  selectedUnitSymbols,
  onSetSelectedUnitTypeNames,
  onSetSelectedUnitSymbols,
  onSetCurrentUnitTypeName,
  unitsDependencyDataStructures,
  existingUnitTypes,
}: UnitsOnboardingWizardUnitTypesScreen): JSX.Element {
  const rows = defaultUnitsData.map((data) => {
    const forceSelectedText = getUnitTypeForceSelectedText(
      data,
      selectedUnitTypeNames,
      unitsDependencyDataStructures,
      existingUnitTypes
    );
    return (
      <UnitsOnboardingWizardUnitTypeRow
        key={data.unitType.name}
        unitType={data.unitType}
        unitTypeUnits={data.units}
        added={selectedUnitTypeNames.includes(data.unitType.name)}
        onSetAdded={(selected: boolean): void => {
          const {newSelectedUnitTypeNames, newSelectedUnitSymbols} = getNewSelectedUnitTypesAndUnits(
            unitsDependencyDataStructures,
            selectedUnitTypeNames,
            selectedUnitSymbols,
            data.unitType.name,
            selected
          );
          onSetSelectedUnitTypeNames(newSelectedUnitTypeNames);
          onSetSelectedUnitSymbols(newSelectedUnitSymbols);
        }}
        forceSelectedText={forceSelectedText}
        onSetCurrentUnitTypeName={onSetCurrentUnitTypeName}
        selectedUnitSymbols={selectedUnitSymbols}
      />
    );
  });

  return (
    <div {...getTestProps({component: 'UnitsOnboardingWizardUnitTypesScreen', element: 'root'})}>{rows}</div>
  );
}
